<div class="service-log-container">
  <h2>Service Log</h2>
  <form (ngSubmit)="addNote()" class="add-note-form">
    <mat-form-field appearance="outline" class="note-input">
      <mat-label>Add a new note</mat-label>
      <textarea matInput [(ngModel)]="newNote" name="note" rows="2"></textarea>
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">Add Note</button>
  </form>
  <div class="notes-list">
    <div class="note-item" *ngFor="let note of (notes$ | async)">
      <button mat-icon-button color="warn" class="delete-btn" (click)="deleteNote(note)">
        <mat-icon>close</mat-icon>
      </button>
      <div class="note-date">{{ note.date }} ({{ note.fromNow }})</div>
      <div class="note-text">{{ note.description }}</div>
      <div class="note-author">{{ note.createdBy }}</div>
    </div>
    <div *ngIf="(notes$ | async)?.length === 0" class="empty-log">No notes yet.</div>
  </div>
</div>